import React, {Component} from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import {change, Field} from 'redux-form';
import {connect} from 'react-redux';
import {compose} from 'recompose';
import {RESOURCES as productResources} from '../fuseProductsResourceMap';
import {checkTokenStatus} from '../shared/tokenFunctions';
import VirtualizedSelectInput from '../components/VirtualizedSelectInput';

/**
 * A SelectInput component with Product Category choices populated from Product Type value.
 *
 */
class ProductCategoryByTypeDependentSelectInput extends Component {
    constructor(props) {
        super(props);

        let dependentProp = (props['dependentProp'] && props[props['dependentProp']]) ? props[props['dependentProp']] : null;

        this.state = {
            sourceParam: dependentProp,
            selectChoices: [],
            selectedId: null,
        };

        this.handleSelectChange = this.handleSelectChange.bind(this);
    }

    componentDidMount() {
        if (
            !this.props.dependsOn ||
            (this.props.dependsOn && this.props.dependsOnValue)
        ) {
            this.fetchData(this.props);
        }
        if (this.props.forceReset) {
            this.props.dispatch(change(this.props.formReference, this.props.sourceName, ''));
        }
    }

    componentWillReceiveProps(nextProps) {
        // If dependentProp changes value, update the value
        const propName = this.props['dependentProp'];
        if (nextProps[propName] !== this.props[propName]) {
            this.setState({
                sourceParam: nextProps[propName],
                selectedId: null,
            });
            this.props.dispatch(change(this.props.formReference, this.props.sourceName, ''));
        }
    }

    componentDidUpdate(prevProps) {
        // If dependentProp value changes, retrieve data
        const propName = this.props['dependentProp'];
        if (prevProps[propName] !== this.props[propName]) {
            this.fetchData(this.props);
        }
    }

    fetchData(props) {
        // Assemble the URI
        const params = {
            filter: {
                type: encodeURIComponent(props[props['dependentProp']])
            },
            pagination: {page: 1, perPage: 10000},
            sort: {field: "name", order: "ASC"}
        };
        const resource = productResources.ProductCategories.GET_LIST(params);

        // Retrieve the data and assign results to the Select choices
        import('../shared/functions')
            .then(functions => {
                const tokenStatus = checkTokenStatus(null);
                if (tokenStatus.expired) {
                    return;
                }
                axios({
                    method: 'get',
                    url: resource.uri,
                    headers: functions.getGetHeaders()
                }).then((result) => {
                    if (result.data.payload) {
                        this.setState({
                            selectChoices: result.data.payload
                        });
                    }
                }).catch((error) => {
                    if (error.response) {
                        // Server response outside 2xx
                        console.log(error.response.data);
                    } else if (error.request) {
                        // No response
                        console.log(error.request);
                    } else {
                        console.log('Error', error.message);
                    }
                });
            });
    }

    handleSelectChange(event, index) {
        const selectedId = index;
        // Retrieve the Product Category from the choices list based on the selected ID
        if (selectedId) {
            const category = this.state.selectChoices.find(p => p.id === selectedId);
            if (category) {
                this.setState({
                    selectedId: selectedId
                });
                this.props.dispatch(change(this.props.formReference, this.props.sourceName, category.id));
            }
        } else {
            this.setState({
                selectedId: ''
            });
            this.props.dispatch(change(this.props.formReference, this.props.sourceName, ''));
        }
    }

    render() {
        return (
            <span>
               <Field name={this.props.sourceName}
                      component={VirtualizedSelectInput}
                      choices={this.state.selectChoices}
                      label={this.props.label}
                      optionText="name"
                      onChange={this.handleSelectChange}
                      allowEmpty
                      options={{
                          className: this.props.className,
                          clearable: false,
                          placeholder: this.props.label
                      }}
               />
            </span>
        );
    }
}

function mapStateToProps(state, props) {
    let filterValue = null;
    if (props.dependsOn && props.formReference) {
        let formState = state.form[props.formReference];
        if (formState && formState.values) {
            filterValue = formState.values[props.dependsOn];
            return {
                dependsOnValue: filterValue
            }
        }
    }

    return {
        isLoading: false
    };
}

ProductCategoryByTypeDependentSelectInput.propTypes = {
    addField: PropTypes.bool.isRequired,
    className: PropTypes.string,
    dependentProp: PropTypes.string,
    formReference: PropTypes.string,
    dependentFilterValue: PropTypes.oneOfType([
        PropTypes.bool,
        PropTypes.number,
        PropTypes.string,
    ]),
    forceReset: PropTypes.bool,
    resource: PropTypes.string,
    selectedId: PropTypes.string,
    sourceName: PropTypes.string
};

ProductCategoryByTypeDependentSelectInput.defaultProps = {
    addField: true,
    className: '',
    dependentFilterValue: null,
    dependentProp: null,
    forceReset: false,
    formReference: null,
    resource: "ProductCategories",
    selectedId: null,
    sourceName: 'category_id'
};

const enhance = compose(
    connect(mapStateToProps)
);

export default enhance(ProductCategoryByTypeDependentSelectInput);



// WEBPACK FOOTER //
// ./src/Fuse/components/ProductCategoryByTypeDependentSelectInput.js